import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

import { MainContent, PageHeading } from '../components/Shell/Content';
import Tabs from '../components/Tabs';

import { getOrganization, updateOrganization } from '../api/admin';

import useAsync from '../hooks/useAsync';
import useFlags from '../hooks/useFlags';

const Customer = () => {
	const { id } = useParams();
	const navigate = useNavigate();

	const { value: organization, execute: refreshOrganization } = useAsync(
		getOrganization,
		{
			defaultPayload: id,
		}
	);

	const { execute: onUpdateOrganization } = useAsync(updateOrganization, {
		immediate: false,
	});

	const { all: allFlags } = useFlags();

	return (
		<MainContent>
			<PageHeading
				onBack={() => navigate('/admin/customers')}
				divider={false}
			>
				{organization?.name}
			</PageHeading>
			<div>
				<Tabs
					tabs={[
						{ name: 'Details', key: 'details' },
						{ name: 'Flags', key: 'flags' },
					]}
				>
					{(currentTab) => {
						if (currentTab === 'details') {
							return <div>Details</div>;
						}
						if (currentTab === 'flags') {
							return (
								<div>
									<div className="space-y-5 ml-4">
										{allFlags?.map((flag) => (
											<div className="relative flex items-start items-center">
												<div className="flex h-6 items-center">
													<input
														id={flag?.key}
														aria-describedby="comments-description"
														name={flag?.key}
														type="checkbox"
														className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600"
														onChange={(e) => {
															let flags = organization?.flags;
															const index = organization?.flags?.indexOf(
																flag?.key
															);

															if (e.target.checked) {
																if (index < 0) {
																	organization?.flags?.push(flag?.key);
																}
															} else {
																if (index > -1) {
																	organization?.flags?.splice(index, 1);
																}
															}

															onUpdateOrganization({ id, flags }, () =>
																refreshOrganization()
															);
														}}
														checked={organization?.flags?.includes(flag?.key)}
													/>
												</div>
												<div className="ml-3 text-xs">
													<label htmlFor={flag?.key} className=" text-gray-900">
														{flag?.name}
													</label>
												</div>
											</div>
										))}
									</div>
								</div>
							);
						}
					}}
				</Tabs>
			</div>
		</MainContent>
	);
};

export default Customer;
